
//Product Base
export function setBaseProductName(name) {
    return {
        type: "SET_PRODUCT_BASE_NAME",
        payload: name
    }
}
export function setBaseProductBarcode(barcode) {
    return {
        type: "SET_PRODUCT_BASE_BARCODE",
        payload: barcode
    }
}

export function setBaseProductInternalCode(code) {
    return {
        type: "SET_PRODUCT_BASE_INTERNALCODE",
        payload: code
    }
}

export function setBaseProductPrice(price) {
    return {
        type: "SET_PRODUCT_BASE_PRICE",
        payload: price
    }
}
export function setBaseProductCost(cost) {
    return {
        type: "SET_PRODUCT_BASE_COST",
        payload: cost
    }
}
export function setBaseProductInitialStock(initialStock) {
    return {
        type: "SET_PRODUCT_BASE_INITIAL_STOCK",
        payload: initialStock
    }
}
//End product

export function setProductsList(e) {
    return {
        type: 'SET_PRODUCTS_LIST',
        payload: e.target.value
    }
}

export function setUnits(units) {
    return {
        type: "SET_UNITS",
        payload: units
    }
}

export function setUnit(unit) {
    return {
        type: "SET_UNIT",
        payload: unit
    }
}

export function setCategorie(categorie) {
    return {
        type: "SET_CATEGORIE",
        payload: categorie
    }
}

export function setCategories(categories) {
    return {
        type: "SET_CATEGORIES",
        payload: categories
    }
}


export function setMaskPrice(mask) {
    return {
        type: "SET_MASK_PRICE",
        payload: mask
    }
}
export function setMaskCost(mask) {
    return {
        type: "SET_MASK_MASK",
        payload: mask
    }
}

export function clearProductInputs() {
    return {
        type: "CLEAR_PRODUCT_INPUTS",
        payload: null
    }
}





// WEBPACK FOOTER //
// ./src/components/pages/products/base/actions.js